import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiDownload, FiEye } from 'react-icons/fi';
import { LoadingGrid } from '../../components/UI/Loading';
import BottomTabMenu from '../../components/UI/BottomTabMenu';
import { clientesService } from '../../services';

const ClienteHistorial = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [historial, setHistorial] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadHistorial();
  }, [id]);

  const loadHistorial = async () => {
    setIsLoading(true);
    setError(null);

    try {
      // Obtener historial de compras desde la API
      const result = await clientesService.getHistorialCompras(id, {
        skip: 0,
        limit: 20
      });

      if (result.success) {
        // Manejar diferentes estructuras de respuesta
        const dataArray = Array.isArray(result.data)
          ? result.data
          : (result.data?.items || result.data?.purchases || []);

        const historialData = dataArray.map(h => ({
          id: h.id,
          fecha: h.purchase_date || h.invoice_date || h.created_at,
          numeroFactura: h.invoice_number || `INV-${h.invoice_id || h.id}`,
          tipo: h.type || 'factura',
          productos: (h.items || h.products || []).map(p => ({
            nombre: p.product_name || p.description || p.name,
            cantidad: p.quantity || 0,
            precio: p.unit_price || p.price || 0
          })),
          subtotal: h.subtotal || 0,
          impuestos: h.tax_amount || h.taxes || 0,
          total: h.total || h.total_amount || 0,
          estado: h.status || h.payment_status || 'pendiente',
          metodoPago: h.payment_method,
          diasVencimiento: h.days_overdue
        }));

        setHistorial(historialData);
      } else {
        setError(result.message || 'Error al cargar el historial');
      }
    } catch (error) {
      console.error('Error cargando historial:', error);
      setError('Error de conexión al cargar el historial');
    } finally {
      setIsLoading(false);
    }
  };

  const handleDescargar = () => {
    console.log('Descargar historial');
  };

  if (isLoading) {
    return <LoadingGrid count={3} message="Cargando historial..." />;
  }

  const totalCompras = historial.reduce((sum, item) => sum + item.total, 0);

  return (
    <div className="cliente-historial-page">
      {/* Header */}
      <div className="page-header-simple">
        <button onClick={() => navigate(`/system/clientes/${id}`)} className="btn btn--ghost">
          <FiArrowLeft /> Volver
        </button>
        <h1 className="page-title">HISTORIAL DE COMPRAS</h1>
        <button onClick={handleDescargar} className="btn btn--outline">
          <FiDownload /> Descargar
        </button>
      </div>

      {/* Error message */}
      {error && (
        <div className="alert alert--danger" style={{ marginBottom: '20px' }}>
          {error}
        </div>
      )}

      {/* Resumen */}
      <div className="historial-summary">
        <div className="summary-card">
          <div className="summary-label">Total de Compras</div>
          <div className="summary-value">${totalCompras.toLocaleString()}</div>
        </div>
        <div className="summary-card">
          <div className="summary-label">Facturas</div>
          <div className="summary-value">{historial.length}</div>
        </div>
      </div>

      {/* Lista de historial */}
      {historial.length === 0 ? (
        <div className="empty-state">
          <p>No hay historial de compras para este cliente</p>
        </div>
      ) : (
      <div className="historial-list">
        {historial.map((venta) => (
          <div key={venta.id} className="historial-card">
            <div className="historial-header">
              <div className="factura-info">
                <strong>{venta.numeroFactura}</strong>
                <span className="fecha">{new Date(venta.fecha).toLocaleDateString()}</span>
              </div>
              <div className="monto-info">
                <span className="total">${venta.total.toLocaleString()}</span>
                <span className={`estado ${venta.estado}`}>
                  {venta.estado === 'pagada' ? 'Pagada' : 'Pendiente'}
                </span>
              </div>
            </div>

            <div className="historial-body">
              {venta.productos.map((producto, index) => (
                <div key={index} className="producto-line">
                  <span className="cantidad">{producto.cantidad}x</span>
                  <span className="nombre">{producto.nombre}</span>
                  <span className="precio">${producto.precio.toLocaleString()}</span>
                </div>
              ))}
            </div>

            <div className="historial-footer">
              <div className="subtotals">
                <div className="subtotal-line">
                  <span>Subtotal:</span>
                  <span>${venta.subtotal.toLocaleString()}</span>
                </div>
                <div className="subtotal-line">
                  <span>Impuestos:</span>
                  <span>${venta.impuestos.toLocaleString()}</span>
                </div>
              </div>
              <button className="btn btn--outline btn--small">
                <FiEye /> Ver Detalles
              </button>
            </div>
          </div>
        ))}
      </div>
      )}

      {/* Menú inferior */}
      <BottomTabMenu baseRoute={`/system/clientes/${id}`} currentTab="historial" />
    </div>
  );
};

export default ClienteHistorial;
